import React, { useState } from "react";
import {Box,Typography,TextField,Button,CircularProgress,Paper,Table,TableBody,TableCell,TableContainer,TableHead,TableRow,Grid,} from "@mui/material";
import { BASE_URL } from "../../App";
import axios from "axios";
import Swal from "sweetalert2";

const ServiceCallCancellationReport = () => {
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState([]);
  const [error, setError] = useState("");
  const loginid = localStorage.getItem("LOGIN_ID");

  const handleGetDetails = async () => {
    if (!token.trim()) {
      setError("Token number is required.");
      return;
    }

    setError("");
    setLoading(true);
    setDetails([]);

    try {
      const response = await axios.post(`${BASE_URL}/getTokenDetails`, {
        loginid: loginid,
        token_no: token,
      });
      const data = Array.isArray(response.data) ? response.data : [response.data];
      setDetails(data);
    } catch (err) {
      const msg =
        err.response?.data?.message || "Failed to fetch details.";
      setError(msg);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: msg,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancelRequest = async () => {
    if (!token.trim()) return;

    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/cancelToken`, {
        token_no: token,
        loginid: loginid,
        // requestedBy :requestedBy,
      });

      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.data.message || "Cancellation successful.",
      });

      if (response.data.details) {
        const data = Array.isArray(response.data.details)
          ? response.data.details
          : [response.data.details];
        setDetails(data);
      } else {
        setDetails([]);
      }
    } catch (err) {
      const msg =
        err.response?.data?.message || "Failed to submit cancellation request.";
      Swal.fire({
        icon: "error",
        title: "Error",
        text: msg,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* <Box sx={{ backgroundColor: "dimgray", p: 2, mb: 3 }}>
        <Typography variant="h6" color="white">
          SERVICE CALL CANCELLATION STATUS
        </Typography>
      </Box> */}

      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={3}>
          {/* <Typography>TOKEN NUMBER</Typography> */}
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            size="small"
            label="Enter Token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <Button variant="contained" onClick={handleGetDetails}>
            GET DETAILS
          </Button>
        </Grid>
      </Grid>

      {loading ? (
        <Box sx={{ textAlign: "center", mt: 4 }}>
          <CircularProgress />
        </Box>
      ) : details.length > 0 ? (
        <TableContainer component={Paper} sx={{ mt: 4 }}>
          <Table>
            <TableHead>
              <TableRow>
                {/* Table Header with Light Blue Background */}
                {Object.keys(details[0] || {}).map((key) => (
                  <TableCell
                    key={key}
                    sx={{
                      backgroundColor: "#ADD8E6", // Light Blue
                      fontWeight: "bold",
                    }}
                  >
                    {key}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {details.map((row, index) => (
                <TableRow key={index}>
                  {Object.values(row).map((val, idx) => (
                    <TableCell key={idx}>{val}</TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : null}

      {details.length > 0 && (
        <Box sx={{ mt: 3 }}>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancelRequest}
          >
            CANCEL REQUEST
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ServiceCallCancellationReport;
